module.exports = __webpack_public_path__ + "static/media/video2.19667022.mp4";